import React from 'react'
import { Flex } from 'antd'
import ClassName from 'clsx'
import Styles from './style.module.scss'

const defaultBackground = 'assets/feature_banner.png'

interface Props {
  title: string
  description: string
  color: string
  children?: React.ReactNode
  backgroundImage: string
  position: 'middle' | 'left'
  aspectRatio: string
}

export default function Index({
  title,
  description,
  children,
  color,
  backgroundImage = defaultBackground,
  position = 'middle',
  aspectRatio = '1440/320',
}: Partial<Props>) {
  return (
    <Flex
      vertical
      align='center'
      justify='center'
      className={Styles.featureBanner}
      style={{
        color: color,
        background: `url(${backgroundImage}) no-repeat center/cover`,
        aspectRatio: aspectRatio,
      }}
    >
      <Flex vertical className={ClassName(Styles.content, position && Styles[position])}>
        {title && <h1 className={Styles.title}>{title}</h1>}
        {description && <div className={Styles.desc}>{description}</div>}
      </Flex>
    </Flex>
  )
}
